import React from 'react';
import { useTranslation } from 'react-i18next';
import { AppButton, Box, Inscription, Preloader, RoundCloseIcon, useResponsive } from '@common-fe/common-fe';

import { CloseActionCardType } from '@/modules/transaction/components/Cards/Cards.types.ts';

import { CardStatusActionWrap } from '../ChangeStatusCardModal.styles';

import CardActionCardHeader from './CardActionCardHeader';

interface CardCloseActionCardProps {
  loadingButton: boolean;
  onOpenCloseConfirmationModal: () => void;
  displayType: CloseActionCardType;
}

const CardCloseActionCard: React.FC<CardCloseActionCardProps> = ({
  loadingButton,
  onOpenCloseConfirmationModal,
  displayType,
}) => {
  const { isMobile } = useResponsive();
  const { t } = useTranslation();
  const closeCardLabel = t('Close Card');
  const cannotReopenLabel = t('You cannot reopen this card after closing it');
  const isSecondary = displayType === CloseActionCardType.SECONDARY;
  const isDesktopSecondary = isSecondary && !isMobile;

  return (
    <CardStatusActionWrap
      $isMobile={isMobile}
      $width={isSecondary ? '100%' : undefined}
      $height={isDesktopSecondary ? '96px' : undefined}
      $isCompact={isDesktopSecondary}
      background="canvas"
      round="container1Round"
      justify={isDesktopSecondary ? 'between' : undefined}
      $withBorderShadow
    >
      {displayType === CloseActionCardType.PRIMARY || isMobile ? (
        <>
          <CardActionCardHeader
            icon={<RoundCloseIcon color="danger" size="44px" />}
            title={closeCardLabel}
            description={isMobile ? (
              cannotReopenLabel
            ) : (
              <>
                {t('You cannot reopen this card')}
                <br />
                {t('after closing it.')}
              </>
            )}
          />
          <AppButton
            buttonType="primary"
            color="red"
            width="100%"
            style={{ height: '40px', paddingInline: '12px', border: 'none' }}
            disabled={loadingButton}
            onClick={onOpenCloseConfirmationModal}
          >
            {loadingButton ? (
              <Box width="100%" align="center">
                <Preloader color="white" />
              </Box>
            ) : (
              closeCardLabel
            )}
          </AppButton>
        </>
      ) : (
        <Box direction="row" justify="between" align="center">
          <Box direction="row" align="end">
            <RoundCloseIcon color="danger" size="44px" />
            <Box justify="center" margin={{ left: 'spacing16' }}>
              <Inscription color="textBody" weight="bold" lineHeight="20px">
                {closeCardLabel}
              </Inscription>
              <Inscription color="textBody" lineHeight="20px">
                {cannotReopenLabel}
              </Inscription>
            </Box>
          </Box>
          <AppButton
            buttonType="primary"
            color="red"
            width="180px"
            style={{ height: '40px', paddingInline: '12px', border: 'none' }}
            disabled={loadingButton}
            onClick={onOpenCloseConfirmationModal}
          >
            {loadingButton ? (
              <Box width="100%" align="center">
                <Preloader color="white" />
              </Box>
            ) : (
              closeCardLabel
            )}
          </AppButton>
        </Box>
      )}
    </CardStatusActionWrap>
  );
};

export default CardCloseActionCard;
